var React = require('react');

function ShapeGroup2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.7","d":"M1351.56 398.382C1351.56 398.382 1430.16 967.436 1183.42 1113.81C946.121 1254.59 495.889 952.233 495.889 952.233C495.889 952.233 417.289 383.179 664.028 236.8C901.325 96.0224 1351.56 398.382 1351.56 398.382Z","fill":"#BEE2F1","key":0}),React.createElement("path",{"opacity":"0.7","d":"M404.125 729.031C571.805 807.672 647.842 462.651 846.173 576.245C1044.5 689.838 857.539 283.515 689.859 204.874C522.179 126.233 545.123 405.123 238.95 291.461C-67.2232 177.798 236.445 650.39 404.125 729.031Z","fill":"#EFA891","key":1}),React.createElement("circle",{"opacity":"0.7","cx":"386.5","cy":"101.5","r":"101.5","fill":"#EFA891","key":2})]);
}

ShapeGroup2.defaultProps = {"width":"1461","height":"1218","viewBox":"0 0 1461 1218","fill":"none"};

module.exports = ShapeGroup2;

ShapeGroup2.default = ShapeGroup2;
